// Field validation shared by the API and the SPA so both enforce the same
// rules (profile contact on file + OOB channel inputs, mig 0013).

export const OOB_TEXT_MAX = 50;
export const FRT_POSSESSION_LABEL = 'FRT (internal)';

/** 1–3 digits, e.g. "1", "44". */
export function isValidCountryCode(v: string): boolean {
  return /^\d{1,3}$/.test(v);
}

/** Digits only, 4–14 long; with the country code at most 15 digits (E.164). */
export function isValidPhoneNumber(v: string, countryCode = ''): boolean {
  return /^\d{4,14}$/.test(v) && countryCode.length + v.length <= 15;
}

/** Pragmatic email check: one @, no spaces, a dot in the domain. */
export function isValidEmail(v: string): boolean {
  return v.length <= 254 && /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(v);
}

/** What an OOB entry captures, derived from its type's field_type:
 *  'phone'       country code + number (contact_country_code/contact_value)
 *  'email'       email address (contact_value)
 *  'none'        nothing extra (field_type 'NA')
 *  'device_name' the entry's own Device Name doubles as the value
 *  'text'        free text ≤ OOB_TEXT_MAX, labelled with field_type */
export type OobFieldKind = 'phone' | 'email' | 'none' | 'device_name' | 'text';

export function oobFieldKind(fieldType: string): OobFieldKind {
  const t = fieldType.trim().toLowerCase();
  if (t === 'phone') return 'phone';
  if (t === 'email') return 'email';
  if (t === 'na' || t === 'n/a' || t === '') return 'none';
  if (t === 'device name') return 'device_name';
  return 'text';
}

/** "+1 5551234567" */
export function formatPhone(countryCode: string | null, number: string | null): string {
  if (!number) return '';
  return countryCode ? `+${countryCode} ${number}` : number;
}
